import React, { useEffect, useRef } from "react";
import { BASE_URL } from "../../../global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SearchIcon from "@mui/icons-material/Search";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import PreviewIcon from "@mui/icons-material/Preview";
import DeleteIcon from "@mui/icons-material/Delete";
import Toolbar from "@mui/material/Toolbar";
import { Link, useLocation } from "react-router-dom";
import HelpIcon from "@mui/icons-material/Help";
import Tooltip from "@mui/material/Tooltip";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import { Grid, TextField, Autocomplete, useMediaQuery, Checkbox } from "@mui/material";
import { templateMasterListGuide } from "./guide";
import axiosWithToken from "../../../utils/components/axiosTokenConfig";
import ListWrap from "../../commonComponent/listWrap";
import { paginationrowsPerPageOptions } from "../../../constants/commonConst";

// datatablse packages
var $ = require("jquery");
$.DataTable = require("datatables.net");

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  width: "50% !important",
  height: "40% !important",
};



const columns = [
  { id: "id", label: "Sr. No", minWidth: 40 },

  {
    id: "instrumentName",
    label: "Instrument Name",
    align: "left",
    minWidth: 40,
  },
  {
    id: "tableName",
    label: "Table Name",
    align: "left",
    minWidth: 40,
  },

  // {
  //   id: "unitType",
  //   label: "Unit Type",
  //   align: "left",
  //   minWidth: 40,
  // },
];

function createData(id, instrumentName, tableName, unitType) {
  return {
    id,
    instrumentName,
    tableName,
    unitType,
  };
}

export function TablesList() {
  const templateMasterListGuides = templateMasterListGuide();
  const isMobile = useMediaQuery("(max-width: 600px)");
  const [page, setPage] = React.useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const urlPath = useLocation();
  const [rowsPerPage, setRowsPerPage] = React.useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));
  const [totalRows, setTotalRows] = React.useState(0);
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "Instrument Name");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [templates, setTemplates] = React.useState([]);
  const [instrumentArray, setInstrumentArray] = React.useState([]);
  const [instrumentId, setInstrumentId] = React.useState(null);
  const [staticDsTableArray, setDSStaticTableArray] = React.useState([]);
  const [certStaticTableArray, setCertStaticTableArray] = React.useState([]);
  const [tableName, setTableName] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [rowDaata, setRowData] = React.useState([]);
  const [searched, setSearched] = React.useState(false);
  const [editAccess, setEditAccess] = React.useState(localStorage.getItem("editAccess")?.split(",").map(Number));
  const ref = useRef(null);
  const handleClose = () => setOpen(false);
  const handleOpen = (row) => {
    setTableName(row.tableName);
    let url = BASE_URL;
    axiosWithToken
      .get(url + `datasheetStaticTables?_where=(id,eq,${row.id})`)
      .then((res) => {
        setDSStaticTableArray(res.data);
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
            toast.error("Something Went Wrong!");
          };
      });

    axiosWithToken
      .get(url + `certificateStaticTables?_where=(id,eq,${row.id})`)
      .then((res) => {
        setCertStaticTableArray(res.data);
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
            toast.error("Something Went Wrong!");
          };
      });

    setOpen(true);
  };
  
  const [filterModalOpen, setFilterModalOpen] = React.useState(false);
  const handleFilterOpen = () => setFilterModalOpen(true);
  const handleFilterClose = () => setFilterModalOpen(false);

  const [selected, setSelected] = React.useState([]);
  const handleSelectRow = (id) => {
    setSelected((prev) => {
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id);
      } else {
        return [...prev, id];
      }
    });
  };
  const isSelected = (id) => selected.includes(id);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    sessionStorage.setItem("currentPath", urlPath.pathname);
    sessionStorage.setItem("ListPageCount", newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    sessionStorage.setItem("ListRowsPerPage", event.target.value);
    sessionStorage.setItem("ListPageCount", 0);
  };
  const storedSearchBy = sessionStorage.getItem("searched");
  useEffect(() => {
    if(storedSearchBy){
      setSearched(true);
    }
  }, [storedSearchBy]);

  const search = () => {
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", urlPath.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setPage(0);
    setSearched(true);
    getInstrumentsList();
    getTotalRows();
    fetchTemplateList();
  };
  const clearSearch = () => {
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched", searched);
    sessionStorage.removeItem("currentPath");
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    setPage(0);
    setSearchBy("Instrument Name");
    setSearchKey("");
    setSearched(false); 
  };

  const getQuery = (count) => {
    let whereConditions = "";
    let pagination_settings = "";

    if (searchBy !== "" && searchKey !== "") {
      let colName = {
        "Instrument Name": "instrumentName",
        "Table Name": "tableName",
      }[searchBy];

      whereConditions = `where LOWER(${colName}) like LOWER('%${searchKey}%')`;
    }

    if (rowsPerPage != -1) {
      pagination_settings = `limit ${rowsPerPage} offset ${
        rowsPerPage * Number(page)
      }`;
    }
    let data = {
      query: `select pl.instrumentId,pr.instrumentName,pl.tableName,pl.unitType,pl.id from datasheetStaticTables as pl join instruments as pr on pl.instrumentId = pr.id ${whereConditions} order by pl.id DESC ${pagination_settings}`,
    };

    if (count)
      data.query = `select count(*) as no_of_rows from datasheetStaticTables as pl join instruments as pr on pl.instrumentId = pr.id ${whereConditions} order by pl.id DESC`;

    return data;
  };

   function getTotalRows() {
      let data = getQuery(true);
      axiosWithToken
        .post(BASE_URL + `dynamic`, data)
        .then(async (res) => {
          setTotalRows(res.data[0].no_of_rows);
        })
        .catch((err) => console.log("data fetching error: ", err));
    }
  
    function fetchTemplateList() {
      let data = getQuery();  
      axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then((res) => {
        setTemplates(res.data);
      })
        .catch((err) => console.log("data fetching error: ", err));
    }

  const getInstrumentsList = () => {
    let url = BASE_URL;
    axiosWithToken
      .get(url + "instruments?_where=(status,eq,1)")
      .then((res) => {
        setInstrumentArray(res.data);
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
            toast.error("Something Went Wrong!");
          };
      });
  };

  const submitSiteDelete = async (id) => {
    const url = BASE_URL;
    const idString = (Array.isArray(id) ? id : [id]).join(',');

    try {
      await axiosWithToken.post(url + 'dynamic', {
        query: `DELETE FROM datasheetStaticTables WHERE id IN (${idString});`
      });
    } catch (error) {
      console.log("err",error);
    }

    try {
      await axiosWithToken.post(url + 'dynamic', {
        query: `DELETE FROM certificateStaticTables WHERE id IN (${idString});`
      });
      toast("Template table deleted!");
    } catch (error) {
      console.log("err",error);
    }

      try {
        await axiosWithToken.post(`${url}dynamic`, {
          query: `DELETE FROM datasheetStaticReadings WHERE tableId IN (${idString});`,
        });
      } catch (error) {
        console.log("err",error);
      }
      window.location.reload();
    
  };

  var refresh = () => {
    window.location.reload(false);
    // <Link to="/master/master/standard">Home</Link>
  };

  const generateRowData = (clientList1) => {
    const newRowData = templates?.map((client) => {
      return createData(
        client?.id,
        client?.instrumentName,
        client?.tableName,
        client?.unitType
      );
    });

    setRowData(newRowData);
  };

  const handleSubmit = async (e) => {
    if (instrumentId != null) {
      var jsData = staticDsTableArray[0];
      var certData = certStaticTableArray[0];
      jsData.instrumentId = instrumentId;
      certData.instrumentId = instrumentId;
      delete jsData.id;
      delete jsData.lastModified;
      delete certData.id;
      delete certData.lastModified;
      let url = BASE_URL;
      axiosWithToken
        .post(url + "datasheetStaticTables", jsData)
        .then((res) => {
          // setTimeout(refresh, 1000);
        })
        .catch((error) => {
          console.log(error);
          if (error.message !== "request_aborted") {
            toast.error("Something Went Wrong3!");
          }
        });
      axiosWithToken
        .post(url + "certificateStaticTables", certData)
        .then((res) => {
          toast("Table copied successfully !");
          setTimeout(refresh, 500);
          // setTimeout(refresh, 1000);
        })
        .catch((error) => {
          console.log(error);
          if (error.message !== "request_aborted") {
            toast.error("Something Went Wrong3!");
          }
        });
    } else {
      toast.error("Please select atleast one instrument!");
    }
  };

  useEffect(() => {
    generateRowData(templates);
  }, [templates, instrumentArray]);

  useEffect(() => {
    if (searched==false) {
      getInstrumentsList();
      fetchTemplateList();
      getTotalRows();
    }
    if (searched) {
      setPage(sessionStorage.getItem("ListPageCount") || 0);
    }
  }, [searched]);

    useEffect(() => { 
      getTotalRows();
      fetchTemplateList();
    }, [rowsPerPage, page]);

  const filterSection = () => (
    <Grid
      container
      spacing={2}
      // justifyContent="flex-end"
      alignItems="center"
      style={{ padding: "5px 0px", marginBottom: "2px" }}
    >
      <Grid item xs={12} sm={6} md={2} lg={2}>
        <Autocomplete
          sx={{
            m: 0,
            minWidth: 180,
          }}
          className="Listinputcss"
          size="small"
          value={searchBy}
          id="template_master_list_searchby"
          options={[
            { key: "instrumentName", label: "Instrument Name" },
            {
              key: "tableName",
              label: "Table Name",
            },
          ]}
          renderInput={(params) => <TextField {...params} label="Search By" />}
          onInputChange={(event, newInputValue) => {
            setSearchBy(newInputValue);
            setSearched(false);
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2} lg={2}>
        <TextField
        style={{ width: "100%" }}
          id="template_master_list_searchbytext"
          label={"enter " + searchBy}
          size="small"
          className="Listinputcss"
          variant="outlined"
          value={searchKey}
          inputProps={{
            autoComplete: "off",
          }}
          onChange={(e) => {
            setSearchKey(e.target.value);
            setSearched(false);
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2} lg={1}  textAlign={"left"}>
        <Button
          id="template_master_list_searchbtn"
          variant="contained"
          size="small"
          color={searched ? "error" : "primary"}
          onClick={() => {
            searched ? clearSearch() : search();
          }}
        >
          {searched ? <RestartAltIcon /> : <SearchIcon />}
        </Button>
      </Grid>
    </Grid>
  );
  const filterModal = () => {
    return (
      <Modal open={filterModalOpen} size="md">
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "calc(100% - 30%)",
            backgroundColor: "white",
            // border: "2px solid #000",
            boxShadow: 24,
            padding: "10px",
          }}
        >
          <Button
            variant="contained"
            size="small"
            color="error"
            style={{ float: "right" }}
            onClick={handleFilterClose}
          >
            X
          </Button>
          {filterSection()}
        </Box>
      </Modal>
    );
  };

  return (
    <ListWrap>
        {filterModal()}
        <div>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <h5 className="text-center">
                <u>Table Name: {tableName}</u>
              </h5>
              <br />
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Autocomplete
                    size="small"
                    id="combo-box-demo"
                    options={
                      instrumentArray != null
                        ? instrumentArray.map((item) => {
                            return {
                              id: item.id,
                              instrumentName: item.instrumentName,
                            };
                          })
                        : []
                    }
                    getOptionLabel={(option) =>
                      option.id + ", " + option.instrumentName
                    }
                    renderInput={(params) => (
                      <TextField {...params} label="Select Instrument" />
                    )}
                    onInputChange={(event, newInputValue) => {
                      setInstrumentId(newInputValue.split(",")[0]);
                 }}
                />
                </Grid>
              </Grid>
              <br />
              <Toolbar style={{ padding: "0px", overflow: "auto" }}>
                <Button
                  variant="contained"
                  size="small"
                  sx={{ m: 0 }}
                  onClick={() => {
                    handleSubmit();
                  }}
                >
                  Save
                </Button>
              </Toolbar>
            </Box>
          </Modal>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Toolbar style={{ padding: "0px" }}>
            <Button
              id="template_master_list_createbtn"
              variant="contained"
              size="small"
              component={Link}
              to="/master/editStaticTable/0"
            >
              <b>ADD NEW TEMPLATE</b>
            </Button>
            </Toolbar>
          <Box sx={{ display: "flex", gap: "0rem" }}>
          <Button
            style={{ display: isMobile ? "block" : "none" }}
            onClick={handleFilterOpen}
          >
            <FilterAltIcon />
          </Button>
          <Tooltip title="User Guide" placement="top-start" >
            <Button
              onClick={() => {
                templateMasterListGuides.drive();
              }}
            >
              <HelpIcon />
            </Button>
          </Tooltip>
          </Box>
          </div>
          {!isMobile && filterSection()}
      {selected.length > 0 && (
        <Box sx={{textAlign:"left", margin:"10px 0px"}}>
          <Button
          variant="contained"
          size="small"
          color={"error"}
          onClick={() => {
            if (window.confirm("Really want to delete Template?")){
              submitSiteDelete(selected);
            } 
          }}
          >Multiple Delete</Button>
        </Box>
      )}
     <Box sx={{ width: "100%", overflow: "hidden", display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
       <TableContainer sx={{ flex: 1, overflow: 'auto' }}>
      <Table
        stickyHeader
        aria-label="sticky table"
        size="small"
        id="template_master_list_table"
         sx={{ borderCollapse: "collapse" }}
      >
        <TableHead>
          <TableRow>
          {(editAccess?.includes(2) || editAccess?.includes(0)) && (
            <TableCell padding="checkbox">
              <Checkbox
                indeterminate={selected.length > 0 && selected.length < rowDaata.length}
                checked={selected.length === rowDaata.length}
                onChange={(event) => {
                  if (event.target.checked) {
                    setSelected(rowDaata.map((row) => row.id));
                  } else {
                    setSelected([]);
                  }
                }}
              />
            </TableCell>
            )}
            {columns.map((column) => (
              <TableCell
                key={column.id}
                align={column.align}
                style={{ minWidth: column.minWidth }}
              >
                <b>{column.label}</b>
              </TableCell>
            ))}
            <TableCell>
              <b>Actions</b>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rowDaata?.length > 0 ? (
          rowDaata
            .map((row, index) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                  {(editAccess?.includes(2) || editAccess?.includes(0)) && (
                   <TableCell padding="checkbox">
                    <Checkbox
                      checked={isSelected(row.id)}
                      onChange={() => handleSelectRow(row.id)}  
                    />
                  </TableCell>
                   )}
                  {columns.map((column) => {
                    let value = row[column.id];

                    if (column.id == "id") {
                      value = page * rowsPerPage + index + 1;
                    }
                    return (
                      <TableCell key={column.id} align={column.align}>
                        {column.format && typeof value === "number"
                          ? column.format(value)
                          : value}
                      </TableCell>
                    );
                  })}

                  <TableCell>
                    <ButtonGroup size="small" aria-label="small button group">
                      <Tooltip title="Edit Template" placement="top-start">
                        <Button
                          id="template_master_list_edit"
                          component={Link}
                          to={`/master/editStaticTable/${row.id}`}
                        >
                          <PreviewIcon />
                        </Button>
                      </Tooltip>

                      <Tooltip title="Copy Template" placement="top-start">
                        <span id="template_master_list_copy">
                          <Button
                            id={row.id}
                            key={row.id}
                            ref={ref}
                            disabled={!(editAccess?.includes(5) || editAccess?.includes(0))}
                            onClick={() => {
                              handleOpen(row);
                            }}
                          >
                            <ContentCopyIcon />
                          </Button>
                        </span>
                      </Tooltip>

                      <Tooltip title="Delete Template" placement="top-start">
                        <Button
                          id="template_master_list_delete"
                          disabled={!(editAccess?.includes(2) || editAccess?.includes(0))}
                          onClick={(e) => {
                            if (
                              window.confirm("Really want to delete Template?")
                            ) {
                              submitSiteDelete(row.id);
                            }
                          }}
                        >
                          <DeleteIcon 
	  style={{ color:!(editAccess?.includes(2) || editAccess?.includes(0)) ? 'lightgray' : '#dc3545' }} />
                        </Button>
                      </Tooltip>
                    </ButtonGroup>
                  </TableCell>
                </TableRow>
              );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={columns.length + 1} align="center">
                 <h6><b>Data Not Found</b></h6>
                </TableCell>
              </TableRow>
            )} 
        </TableBody>
      </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={paginationrowsPerPageOptions}
        component="div"
        count={totalRows}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
      <ToastContainer />
       
    </ListWrap>
  );
}